<spinner [center]="true" size="la-2x" color="grey" type="ball-triangle-path"></spinner>
<ng-container *ngIf="action?.input?.data?.dataType == 'object'; else multipleRecord">
  <div>
    <div fxLayout="row" class="mat-h2" fxLayoutAlign="start center">
      Data
    </div>
    <div *ngFor="let data of customRecord; let i = index; trackBy: trackByFn"  fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5">
        <div fxFlex="20" fxLayoutAlign="center center">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Attribute</mat-label>
            <input matInput placeholder="Key" (ngModelChange)="customAttributeInputAdded($event)" [(ngModel)]="data.__id" class="input-field">
          </mat-form-field>
        </div>
        <div fxFlex="20" fxLayoutAlign="center center">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Data Type</mat-label>
            <mat-select [(ngModel)]="data.dataType" (selectionChange)="onAttributeDataTypeSelected(data)">
              <mat-option *ngFor="let type of availableBoxTypes; trackBy: trackByFn" [value]="type">
                {{type}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="50" fxLayoutAlign="center center">
          <!-- TODO - USE Widgets seperatly once it got refactored for simple usable -->
          <mat-form-field class="full-width" appearance="outline" *ngIf="['string', 'number'].includes(data?.dataType)">
            <mat-label>Value</mat-label>
            <input matInput placeholder="Value" (ngModelChange)="customAttributeInputAdded($event)" [(ngModel)]="data.value" class="input-field">
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width" appearance="outline" *ngIf="['array', 'object'].includes(data?.dataType)">
            <mat-label>JSON Value</mat-label>
            <textarea matInput placeholder="JSON Value" (ngModelChange)="customAttributeInputAdded($event)" [(ngModel)]="data.value" rows="5"></textarea>
          </mat-form-field>
          <mat-form-field  appearance="outline" class="full-width" appearance="outline" *ngIf="['date'].includes(data?.dataType)" >
            <mat-label>Value</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="data.value"  (ngModelChange)="customAttributeInputAdded($event)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" class="full-width" appearance="outline" *ngIf="['datetime'].includes(data?.dataType)">
            <mat-label>Value</mat-label>
            <input matInput
              onfocus="this.showPicker()"
              type="datetime-local"
              #datetimeInput="ngModel"
              [(ngModel)]="data.value"
              (ngModelChange)="customAttributeInputAdded($event)"
              placeholder="Value" >
          </mat-form-field>
          <div  *ngIf="['boolean'].includes(data?.dataType)" fxLayoutAlign="start start">
            <mat-checkbox (change)="customAttributeInputAdded($event)" [checked]="data.value"></mat-checkbox>
          </div>
        </div>
        <!--
        <app-field-picker  [inputFieldMap]="fieldMap" fxLayoutAlign="end start"
            (selectedFields)="insertCursor($event, data)">
        </app-field-picker>  -->
        <div fxLayoutAlign="start end" fxFlex="10" >
          <button mat-icon-button matTooltip="Delete attribute" (click)="deleteCustomRecord(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center">
      <button style="cursor: pointer;" (click)="addNewAttribute()" color="primary" mat-stroked-button matTooltip="Add attribute">
        <mat-icon>add_circle_outline</mat-icon>
        Add attribute
      </button>
    </div>
  </div>
</ng-container>

<ng-template style="width: 80%;" #multipleRecord>
  <div *ngIf="!isCreateCustomAttribute">
    <mat-form-field class="full-width">
      <mat-label>Select additional data input fields</mat-label>
      <mat-select [formControl]="attributeControl" multiple>
        <mat-select-trigger> Choose attributes </mat-select-trigger>
        <mat-option
          *ngFor="let attribute of boxObjectAttributes; trackBy: trackByFn"
          [value]="attribute"
          [disabled]="isAttributeDisabled(attribute)"
        >
          {{ attribute.name }}
        </mat-option>
      </mat-select>
      <mat-hint *ngIf="hasDisabledAttributes()">
        Fields that are not available for selection are uneditable.
      </mat-hint>
    </mat-form-field>

    <mat-chip-listbox>
      <mat-chip-option
        *ngFor="let attribute of selectedAttributes; trackBy: trackByFn"
        [selectable]="true"
        [removable]="!isAttributeDisabled(attribute)"
        (removed)="remove(attribute)"
      >
        {{ attribute.name }}
        <mat-icon matChipRemove *ngIf="!isAttributeDisabled(attribute)"
          >cancel</mat-icon
        >
      </mat-chip-option>
    </mat-chip-listbox>

    <div *ngIf="inputList.length" style="margin-top: 10px">
      <div
        *ngFor="let record of recordList; let i = index; trackBy: trackByFn"
        fxLayout="column"
        style="margin-bottom: 10px"
      >
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <mat-expansion-panel [expanded]="true" fxFlex="90">
            <mat-expansion-panel-header>
              <b>Record&nbsp;{{ i + 1 }}</b>
            </mat-expansion-panel-header>
            <div *ngFor="let item of inputList; trackBy: trackByFn">
              <mat-form-field class="example-full-width">
                <mat-label>{{ item.name }}</mat-label>
                <input
                  style="width: 60%"
                  matInput
                  [(ngModel)]="record[item.__id]"
                  [placeholder]="item.name"
                  [required]="item.required"
                  (ngModelChange)="trackChanges()"
                />
                <mat-error *ngIf="item.required && !record[item.__id]">
                  {{ item.name }} is required
                </mat-error>
              </mat-form-field>
            </div>
          </mat-expansion-panel>

          <div fxFlex="10" fxLayout="column" fxLayoutAlign="center start">
            <button
              mat-icon-button
              matTooltip="Delete Record"
              [disabled]="recordList.length < 2"
              (click)="deleteRecord(i)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayoutAlign="end center" style="margin-top: 20px; margin-right: 10px;">
        <button
          style="cursor: pointer"
          (click)="addRecord(inputList)"
          color="primary"
          mat-stroked-button
          matTooltip="Add record"
        >
          <mat-icon>add_circle_outline</mat-icon>
          Add Record
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!isCreateCustomAttribute">
    <button mat-stroked-button color="primary" (click)="isCreateCustomAttribute = true">Add custom attribute</button>
  </div>
  <div *ngIf="isCreateCustomAttribute">
    <div>
      <p>Create a custom fields</p>
      <div fxLayout="column">
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-label>Attribute</mat-label>
            <input matInput (input)="onChangeOfAttributeName($event.target.value)" [(ngModel)]="cutomAttribute.__id" placeholder="Enter the attribute name." required>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Attribute Type</mat-label>
            <mat-select [(ngModel)]="cutomAttribute.dataType">
              <mat-option *ngFor="let type of availableBoxTypes; trackBy: trackByFn" [value]="type">
                {{type}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
    </div>
    <div fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="8px">
      <div fxLayout="row" fxLayoutAlign="start center">
        <button mat-raised-button color="primary" [disabled]="!cutomAttribute.__id" (click)="addCustomAttribute(); isCreateCustomAttribute = false">Add</button>
        <button mat-stroked-button color="primary" (click)="isCreateCustomAttribute = false">Cancel</button>
      </div>
    </div>

  </div>
</ng-template>


